import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const AppViewOverlay = styled(Box)`
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.palette.secondary.main};
`;
